import { createFileRoute } from '@tanstack/react-router';
import { onboardingEntry } from '@/lib/onboardingEntry.ts';

/*
 * `/onboarding` has no screen of its own — the first step is the landing
 * screen, the same way `/settings` lands on its first tab.
 *
 * The provider's consent screen returns here, and lands on that same first step
 * with the calendar now connected, which is where it says so.
 */
export const Route = createFileRoute('/onboarding/')({
  beforeLoad: ({ search }) => onboardingEntry(search),
});
